import { useEffect } from 'react';
import { navigate } from "@reach/router"

const BestFireDepartmentAppPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/emergency-services/');
  }, []);
  return null;
};

export default BestFireDepartmentAppPage;